import BoxComment from './BoxComment.component';

export default BoxComment;
